import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openTeamDropdown, setOpenTeamDropdown] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown(false);
    setOpenTeamDropdown(false);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        गट ग्रामपंचायत मानोरा | पंचायत समिती भिवापूर, जि. नागपूर
      </div>

      {/* Main Header */}
      <header className="main-header">
        <div className="header-container">
          {/* Left - Service Number */}
          <div className="service-section">
            <div className="service-card">
              <span>सेवा क्रमांक</span>
              <strong>9975797462</strong>
            </div>
          </div>

          {/* Center - Emblem & Title */}
          <div className="logo-section">
            <img src="/images/sj1.jpg" alt="राष्ट्रीय चिन्ह" className="emblem" />
            <div className="title-group">
              <h1>गट ग्रामपंचायत मानोरा</h1>
              <p className="cert">ISO 9001:2015 प्रमाणित</p>
            </div>
          </div>

          {/* Right - Photos */}
          <div className="photos-section">
            <div className="photos-grid">
              <img src="/images/raje.jpg" alt="राजे" className="photo" />
              <img src="/images/Gadgemaharaj.jpg" alt="गदगे महाराज" className="photo" />
              <img src="/images/tujdojimaharaj.jpeg" alt="तुकोजी महाराज" className="photo" />
            </div>
          </div>

          {/* Hamburger */}
          <button
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="मेनू उघडा/बंद करा"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Navigation */}
        <nav className={`main-nav ${menuOpen ? "active" : ""}`}>
          <div className="nav-wrapper">
            <Link to="/" onClick={closeMenu}>मुख्य पृष्ठ</Link>
            <Link to="/aboutus" onClick={closeMenu}>ग्रामपंचायत-बद्धल</Link>
           

            {/* नवीन टीम Dropdown */}
            <div className="dropdown">
              <button
                className="dropdown-btn"
                onClick={() => setOpenTeamDropdown(!openTeamDropdown)}
              >
                कार्यालय / प्रतिनिधी ▾
              </button>
              {openTeamDropdown && (
                <div className="dropdown-content team-dropdown">
                  <Link to="/sarpanch" onClick={closeMenu}>सरपंच</Link>
                  <Link to="/upsarpanch" onClick={closeMenu}>उपसरपंच</Link>
                  <Link to="/sachiv" onClick={closeMenu}>ग्रामपंचायत अधिकारी</Link>
                </div>
              )}
            </div>

            {/* जुना दाखले Dropdown */}
            <div className="dropdown">
              <button
                className="dropdown-btn"
                onClick={() => setOpenDropdown(!openDropdown)}
              >
                दाखले ▾
              </button>
              {openDropdown && (
                <div className="dropdown-content">
                  <Link to="/janm-dakhala" onClick={closeMenu}>जन्म दाखला</Link>
                  <Link to="/mrut-dakhala" onClick={closeMenu}>मृत्यू दाखला</Link>
                  <Link to="/vivah-dakhala" onClick={closeMenu}>विवाह दाखला</Link>
                </div>
              )}
            </div>

            <Link to="/devlopment" onClick={closeMenu}>विकास कामे</Link>
            <Link to="/gallery" onClick={closeMenu}>छायाचित्र</Link>
             <Link to="/team" onClick={closeMenu}>सदश्य</Link>
             <Link to="/meeting" onClick={closeMenu}>ग्रामसभा</Link>
            <Link to="/contact" onClick={closeMenu}>संपर्क</Link>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;